
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Action_Btn.css'

const Action_Btn = (props) => {
    return (
        <button className="Action_Btn">
            <div className='icon_holder'>
                <FontAwesomeIcon icon={props?.icon} className='dynamic_icon' />
            </div>
            <p className='btn_text'>{props?.btn_name}</p>
        </button>
    )
}

export default Action_Btn
